import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlidesTall"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V18H8V22H20V6H16V2H4ZM14 6V4H6V16H8V6H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesTall;
